<template>
  <div class="userPicture" 
    >
    
    
    
    <div class="pic-body">
      <div class="pic-one">{{$t('other.a1987')}}</div>
      <div class="pic-txt">
        {{$t('other.a1988')}}<span style="color:#409eff">4—5</span>{{$t('other.a1989')}} 
      </div>
      <div class="pic-txt">
        {{$t('other.a1990')}}<span style="color:#409eff">{{$t('other.a1991')}}</span>{{$t('other.a1992')}}
      </div>
      <div class="pic-txt">
        {{$t('other.a1993')}}<span style="color:#409eff">{{$t('other.a1994')}}</span>{{$t('other.a1995')}}
      </div>
      <div class="pic-one">
          <el-button type="primary" @click="gobottom">{{$t('other.a1996')}}</el-button>
      </div>
    </div>
    <div>
        <div>
          <el-row style="height: 20rem; margin-top: 2rem">
      <el-col :span="14" class="center">
        <div
          style="
            height: 19rem;
            width: 35rem;
            border: 1px solid #409eff;
            border-radius: 5px;
            padding: 0.3rem;
          "
          id="categoryPortraitEchart"
        ></div>
      </el-col>
      <el-col :span="10">
        <ul class="first_wrapper">
          <li class="first_category" v-if="categoryPortrait != null">
            <div class="item_category">
              {{$t('other.a1943')}}：{{ categoryPortrait.category_cn }}
            </div>
            <div class="item_category">
              {{$t('other.a1997')}}：{{ categoryPortrait.intervalMeanAvg }}天
            </div>
            <div class="item_category">
              {{$t('other.a1998')}}：{{ categoryPortrait.orderNumAvg }}
            </div>
            <div class="item_category">
              {{$t('other.a1999')}}：{{ categoryPortrait.lastOrderAvg }}天
            </div>
            <div class="item_category">
              {{$t('other.a2000')}}：{{ categoryPortrait.premiumMeanAvg }}%
            </div>
            <div class="item_category">
              {{$t('other.a2001')}}：{{this.nation == 'TH'?'฿':'' || this.nation == 'MY'?'RM':'' || this.nation == 'PH'?'P':'' || this.nation == 'ID'?'RP':'' || this.nation == 'VN'?'VND':''}}{{ categoryPortrait.priceSumAvg }}
            </div>
            <div class="item_category">
              {{$t('other.a2002')}}：{{ categoryPortrait.rejectionNumAvg }}
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
      <el-alert
    :title="$t('other.a2003')"
    :closable="false"
    type="info"
    effect="dark">
  </el-alert>
    </div>
    <div class="user_card">
      
      <el-tabs type="border-card" v-model="categorys_l" @tab-click="tabclick_s()" style="width: 1270px;height:620px">
        <!-- <el-button type="primary" @click="gobottom">去到底部</el-button> -->
        <el-tab-pane v-for="(item,index) in categorys" :key="index" :label="item.categoryName" :name="item.categoryId">

        </el-tab-pane>
        
      
      <el-tabs
        type="card"
        style="width: 1270px;"
        v-model="tabName"
        @tab-click="tabclick()"
      >
      <div>
          {{$t('other.a2004')}}：
          <el-select v-model="value" :placeholder="$t('other.a50')" @change="valueCheack">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
      </div>
      
        <el-tab-pane
          :key="item.category"
          v-for="(item, index) in categoryList"
          :label="item.category_cn"
          :name="item.category"
        >
          <el-table :data="tableData" height="420" border style="width: 100%">
            <el-table-column prop="consumerName" :label="$t('other.a2005')" width="180">
            </el-table-column>
            <el-table-column :label="$t('other.a2006')" width="180">
              <template slot-scope="scope">
                
                <span style="margin-left: 10px">{{ table_translation[scope.row.loyaltyLevels] }}</span>
              </template>
            </el-table-column>
            <el-table-column  :label="$t('other.a2007')">
              <template slot-scope="scope">
                
                <span style="margin-left: 10px">{{ table_translation[scope.row.consumptionLevel] }}</span>
              </template>
            </el-table-column>
             <el-table-column  :label="$t('other.a2008')">
              <template slot-scope="scope">
                
                <span style="margin-left: 10px">{{ table_translation[scope.row.priceSensitiveLevel] }}</span>
              </template>
            </el-table-column>

            <el-table-column  :label="$t('other.a2009')">
              <template slot-scope="scope">
                
                <span style="margin-left: 10px">{{ scope.row.orderNumDecimal }}次</span>
              </template>
            </el-table-column>

             <el-table-column  :label="$t('other.a2010')">
              <template slot-scope="scope">
                
                <span style="margin-left: 10px">{{ scope.row.priceSumDecimal }}</span>
              </template>
            </el-table-column>

            <el-table-column  :label="$t('other.a2011')">
              <template slot-scope="scope">
                
                <span style="margin-left: 10px">{{ scope.row.lastOrderDecimal }}{{$t('other.a177')}}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('other.a33')">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  >{{$t('other.a600')}}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-pagination
              
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage1"
              :page-sizes="[10, 30, 50]"
              :page-size="offset"
              layout=" total,sizes, prev, pager, next, jumper"
              :total="recordTotal">
              </el-pagination>
        <!-- <el-pagination
              class="page"
              
              
              @current-change="handleCurrentChange"
              :current-page="currentPage1"
              
              :page-size="offset"
              layout="prev, pager, next,jumper"
               :total="recordTotal"
              >
              </el-pagination> -->
              
      </el-tabs>
      </el-tabs>

      <el-dialog
        :title="$t('other.a2012') + this.buyer_name"
        :visible.sync="dialogVisible"
        width="80%"
        :before-close="handleClose"
      >
      <div class="order_body">
        <div>{{$t('other.a2013')}}:{{buyerUserPortrait.lastOrderDecimal}}{{$t('other.a177')}}</div>
        <div class="order_body_two">{{$t('other.a1997')}}:{{buyerUserPortrait.intervalMeanDecimal}}{{$t('other.a177')}}</div>
      </div>
        <el-table
          :data="tableData_user"
          style="width: 100%"
          height="350"
          border
        >
          <el-table-column prop="ordersn" :label="$t('other.a60')" width="180">
          </el-table-column>
          <el-table-column prop="payTime" :label="$t('other.a589')" width="180">
            <template slot-scope="scope">
                
                <span style="margin-left: 10px">{{ scope.row.payTime == null?$t('other.a147'): scope.row.payTime}}</span>
              </template>
          </el-table-column>
          <el-table-column  :label="$t('other.a583')" width="180">
            <template slot-scope="scope">
                
                <span style="margin-left: 10px">{{ buyer_order[scope.row.orderStatus] }}</span>
              </template>
          </el-table-column>
          <el-table-column prop="totalAmount" :label="$t('other.a2014')" width="180">
          </el-table-column>
          <el-table-column prop="country" :label="$t('other.a481')"> </el-table-column>
          <el-table-column prop="currency" :label="$t('other.a2015')"> </el-table-column>
        </el-table>
        
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small"
            >{{$t('other.a106')}}</el-button
          >
          <el-button type="primary" @click="dialogVisible = false" size="small"
            >{{$t('other.a279')}}</el-button
          >
        </span> -->
        <el-pagination
              
              @size-change="handleSizeChange_or"
              @current-change="handleCurrentChange_or"
              :current-page="currentPage1_or"
              :page-sizes="[10, 30, 50]"
              :page-size="offset_order"
              layout=" total,sizes, prev, pager, next, jumper"
              :total="orderTotal">
              </el-pagination>
      </el-dialog>
    </div>
    <div>
      <el-alert
    :title="$t('other.a2016')"
    :closable="false"
    type="info"
    effect="dark">
  </el-alert>
    </div>
    <div class="user_card">
      
        
      
      <el-tabs
        type="border-card"
        style="width: 1270px;"
        v-model="tabNames"
        @tab-click="tabclick_cu"
         
        @tab-remove="removeTab"
      >

        <el-tab-pane :closable="false" style="height:380px" 
          :key="item.categoryId"
          v-for="(item, index) in customgroup_black"
          :label="item.categoryName"
          :name="item.categoryId"
          >
                          <span slot="label">{{$t('other.a2025')}}</span>
                           <el-radio-group v-model="Shared" style="margin-bottom: 20px;" @change="collapfa">
                            <el-radio-button :label="0">{{$t('other.a2025')}}</el-radio-button>
                            <el-radio-button :label="1" >{{$t('other.a2026')}}</el-radio-button>
                            </el-radio-group>
                            <el-table :data="tableData_cu" height="300" border style="width: 100%">
            <el-table-column prop="consumerName" :label="$t('other.a2005')" width="180">
            </el-table-column>
            
            <el-table-column prop="description" :label="$t('other.a1241')" width="180">
            </el-table-column>
            <el-table-column prop="createdTime" :label="$t('other.a57')" width="180">
            </el-table-column>
            <el-table-column prop="updatedTime" :label="$t('other.a1397')" width="180">
            </el-table-column>
            <!-- <el-table-column
              label="是否共享">
              <template slot-scope="scope">
                  <el-switch
                        v-model="scope.row.isShared"
                        :active-value="1"
                        :inactive-value="2"
                        active-color="#02538C"
                        inactive-color="#B9B9B9"
                        />
              </template>
          </el-table-column> -->

            
            

            <el-table-column :label="$t('other.a33')" >
              <template slot-scope="scope" >
                <el-button
                   v-show="scope.row.isShared == 0"            
                  size="mini"
                  type="primary"
                  @click="Sharingbuyer(scope.$index, scope.row)"
                  >{{$t('other.a2027')}}</el-button
                >
                <el-button
                   v-show="scope.row.isShared == 1"            
                  size="mini"
                  type="primary"
                  @click="shiftbuyer(scope.$index, scope.row)"
                  >{{$t('other.a2028')}}</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                 @click="deleteconsumer(scope.$index, scope.row)"
                  >{{$t('other.a312')}}</el-button
                >
              </template>
            </el-table-column>

            
          </el-table>
          <el-pagination
              
              @size-change="handleSizeChange_cu"
              @current-change="handleCurrentChange_cu"
              :current-page="currentPage1_cu"
              :page-sizes="[10, 30, 50]"
              :page-size="offset_cu"
              layout=" total,sizes, prev, pager, next, jumper"
              :total="recordTotal_cu">
              </el-pagination>

        </el-tab-pane>


        <el-tab-pane
          :key="item.categoryId"
          v-for="(item, index) in customgroup"
          :label="item.categoryName"
          :name="item.categoryId"
          closable
        >
        <el-row>
                            <el-col :span="19">
                              <el-input
                                :placeholder="item.categoryName"
                                :disabled="modifyGroup"
                                v-model="GroupName"
                              ></el-input>
                            </el-col>
                            <el-col :span="5">
                              <el-button
                                v-if="modifyGroup"
                                @click="editgrop(item)"
                                >{{$t('other.a2029')}}</el-button
                              >
                              <el-button
                                v-else
                                @click="confirmModifyGroup(item)"
                                >{{$t('other.a2030')}}</el-button
                              >
                            </el-col>
                          </el-row>
       

          <el-table :data="tableData_cu" height="300" border style="width: 100%">
            <el-table-column prop="consumerName" :label="$t('other.a2005')" width="180">
            </el-table-column>
            
            <el-table-column prop="description" :label="$t('other.a1241')" width="180">
            </el-table-column>
            <el-table-column prop="createdTime" :label="$t('other.a57')" width="180">
            </el-table-column>
            <el-table-column prop="updatedTime" :label="$t('other.a1397')" width="180">
            </el-table-column>
            <!-- <el-table-column
              label="是否共享">
              <template slot-scope="scope">
                  <el-switch
                        v-model="scope.row.isShared"
                        :active-value="1"
                        :inactive-value="2"
                        active-color="#02538C"
                        inactive-color="#B9B9B9"
                        />
              </template>
          </el-table-column> -->

            
            

            <el-table-column :label="$t('other.a33')">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="deleteconsumer(scope.$index, scope.row)"
                  >{{$t('other.a312')}}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              
              @size-change="handleSizeChange_cu"
              @current-change="handleCurrentChange_cu"
              :current-page="currentPage1_cu"
              :page-sizes="[10, 30, 50]"
              :page-size="offset_cu"
              layout=" total,sizes, prev, pager, next, jumper"
              :total="recordTotal_cu">
              </el-pagination>
        </el-tab-pane>
        <el-tab-pane :closable="false" style="height:380px">
                          <span slot="label">{{$t('other.a2031')}}</span>
                          <el-form :model="ruleForm"  ref="ruleForm" label-width="100px"  :label-position="labelPosition">
            <el-form-item :label="$t('other.a2017')"  :required="true">
              <el-input type="text" v-model="ruleForm.pass"></el-input>
            </el-form-item>
            <el-form-item :label="$t('other.a2018')" >
              <el-input type="textarea" v-model="ruleForm.checkPass" :rows=5></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="successshint">{{$t('other.a2032')}}</el-button>
              
  </el-form-item>
            
          </el-form>

                </el-tab-pane>
        
        
              
      </el-tabs>

      <el-dialog
  :title="$t('other.a2019')"
  :visible.sync="Sharing"
  width="30%"
  :before-close="handleClose_sh">
  <el-form  label-width="100px"  :label-position="labelPosition">
            
            <el-form-item :label="$t('other.a1241')" >
              <el-input type="textarea" v-model="describe" :rows=5></el-input>
            </el-form-item>
            
          </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="Sharingos">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="Sharingck">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>

 <el-dialog
  :title="$t('other.a2020')"
  :visible.sync="Sharing_yc"
  width="30%"
  :before-close="handleClose_sh_yc">
  <el-form  label-width="100px"  :label-position="labelPosition">
            
            <el-form-item :label="$t('other.a1241')" >
              <el-input type="textarea" v-model="describes" :rows=5></el-input>
            </el-form-item>
            
          </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="Sharingos_yc">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="Sharingck_yc">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
      <!-- <el-dialog
        title="添加自定义分组"
        :visible.sync="custom_hint"
        width="50%"
        :before-close="handleClose">
        <el-form :model="ruleForm"  ref="ruleForm" label-width="100px"  :label-position="labelPosition">
            <el-form-item :label="$t('other.a2017')"  :required="true">
              <el-input type="text" v-model="ruleForm.pass"></el-input>
            </el-form-item>
            <el-form-item :label="$t('other.a2018')" >
              <el-input type="textarea" v-model="ruleForm.checkPass" :rows=5></el-input>
            </el-form-item>
            
          </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="custom_hint = false">{{$t('other.a106')}}</el-button>
          <el-button type="primary" @click="successshint">{{$t('other.a279')}}</el-button>
        </span>
      </el-dialog> -->

      
    </div>
    </div>
    <!-- <ul  class="first_wrapper">
            <li class="first_category " v-for="(item,index) in categoryList" :key="index" >
                <div class="item_category">{{$t('other.a1943')}}：{{item.category}} ({{item.count}})</div>
                 <div class="item_category">{{$t('other.a1997')}}：{{item.intervalMeanAvg}}</div>
                 <div class="item_category">{{$t('other.a1998')}}：{{item.orderNumAvg}}</div>
                 <div class="item_category">{{$t('other.a1999')}}：{{item.lastOrderAvg}}</div>
                 <div class="item_category">{{$t('other.a2000')}}：{{item.premiumMeanAvg}}</div>
                 <div class="item_category">{{$t('other.a2001')}}：{{item.priceSumAvg}}</div>
                 <div class="item_category">{{$t('other.a2002')}}：{{item.rejectionNumAvg}}</div>
                  <div class="item_category" @click.stop="cateGory(item,1)">{{$t('other.a600')}}</div>
            </li>
        </ul> -->

    <!-- 分页器 -->
    <!-- <div  class="Pager">
        <el-pagination
            @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage1"
        :page-sizes="[15, 20, 30, 50]"
        :page-size="15"
        layout="total, sizes, prev, pager, next, jumper"
        :total="goodsTotal">
        </el-pagination>
    </div> -->
    <div v-if="prostatus" class="pro-body">
      <div class="pro-all">
        <el-steps :active="active" finish-status="success" style="width:100%;height:100px">
          <el-step :title="$t('other.a2021')"></el-step>
          <el-step :title="$t('other.a2022')"></el-step>
          <el-step :title="$t('other.a2023')"></el-step>
        </el-steps>
          <div class="pro-one">
            <div class="pro_pro">{{$t('other.a2033')}}:{{ progress_data[progress_name]}}</div>
            <div class="prosta">{{$t('other.a2034')}}:{{stage}}%</div>
          </div>
          <div class="pro-two">
            <div class="pro-txt">
              <div>{{$t('other.a2035')}}</div>
              <div>{{num_progress}}</div>
              </div>
            <div class="pro-txt">
              <div>{{$t('other.a2036')}}</div>
              <div>{{all_progress == 0 ? $t('other.a2024'): all_progress}}</div>
            </div>
            
          </div>
           <div class="pro-one" v-if="btoonstatus">
             <el-button type="primary" @click="tosucced">{{$t('other.a145')}}</el-button>
            </div>
      </div>
    </div>
    <div class="user_top_s" v-if="shops">
      <div class="top_s">
        <div style="font-size: 22px;
    font-weight: bold;">{{$t('other.a2037')}}</div>
      <div style="font-size:18px;margin-top:30px;cursor: pointer;color:#66b1ff;" @click="authorizes">{{$t('other.a2038')}}</div>
      </div>
      
    </div>
    <div  class="user_top" v-if="showuser">
      <div class="user_body">
        <div style="font-size:22px">{{$t('other.a2039')}}:{{valid_data_num}}</div>
        <el-card class="box-card" style="width:100%">
            <div slot="header" class="clearfix">
              <span>{{$t('other.a2040')}}</span>
              <span style="color:#66b1ff;cursor: pointer;" @click="authorizes">{{$t('other.a2041')}}</span>
            </div>
            <div v-for="(item,index) in valid_shop_list" :key="index" class="text item">
              {{showshopNameByshopIdOne(item)}}
            </div>
        </el-card>
        <div>
           <el-button type="primary" @click="calculate" >{{$t('other.a2042')}}</el-button>
        </div>
        <div>{{$t('other.a2044')}}:{{ getnum(valid_data_num * 0.01) }}({{$t('other.a2043')}}：{{getnum(integral)}})</div>
         <div style="color:#66b1ff;">{{$t('other.a2045')}}</div>
      </div>
      
    </div>
    
  </div>
</template>

<script>
import user from '../../api/moudles/order' 
import api from "../../api/api";
import remind from "../../api/moudles/remind";
import echarts from "echarts";
import chat from '../../api/moudles/chat'
import utils from "../../utils/utils.js";
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      shops:false,
      stage:0,
       options: [{
          value: 'price_sum',
          label: this.$t('other.a2010')
        }, {
          value: 'Last_order',
          label: this.$t('other.a2011')
        }, {
          value: 'rejection_num',
          label: this.$t('other.a2046')
        }, {
          value: 'Interval_mean',
          label: this.$t('other.a2047')
        }, {
          value: 'order_num',
          label: this.$t('other.a2009')
        },
         {
          value: 'Premium_mean',
          label: this.$t('other.a2048')
        }],
        value: 'price_sum',
      active:0,
      progress_name:null,
      num_progress:null,
      all_progress:null,
      prostatus:false,
      progress_data:{
        'getting data':this.$t('other.a2021'),
        'calculate indicators':this.$t('other.a2022'),
        'calculate category':this.$t('other.a2023'),
        'finish':this.$t('other.a2049')
      },
      valid_data_num:null,
      valid_shop_list:[],
      loading:true,
      showuser:null,
      showdata:false,
      nation:'',
      buyer_order:{
        UNPAID: this.$t('other.a118'),
        READY_TO_SHIP:this.$t('other.a2050'),
        RETRY_SHIP:this.$t('other.a2051'),
        SHIPPED:this.$t('other.a2052'),
        TO_CONFIRM_RECEIVE:this.$t('other.a2053'),
        IN_CANCEL:this.$t('other.a2054'),
        CANCELLED:this.$t('other.a840'),
        TO_RETURN:this.$t('other.a2055'),
        COMPLETED:this.$t('other.a119'),
        
      },
      buyerUserPortrait:[],
      consumerName:'',//买家名字
      describe:'',//共享描述
      describes:'',//移出描述
      Sharing:false,//打开共享描述弹框
      Sharing_yc:false,//打开移出共享弹框
      modifyGroup:true,//修改框是否可修改
      GroupName:'',//修改框内的内容
      Shared:0,//是否共享
      isCollapse:false,
      labelPosition: 'left',
      ruleForm: {
          pass: '',
          checkPass: '',
          
        },
      custom_hint:false,//添加自定义分组弹窗
      customgroup:[],
      customgroup_gr:[],
      customgroup_black:[],
      categorys_l:0,
      categorys:[{
        categoryName:this.$t('other.a2056')
      },
      {
        categoryName:this.$t('other.a2057')
      },
      {
        categoryName:this.$t('other.a2058')
      },
      
      
      ],
      offset:10,
      offset_cu:10,
      recordTotal:0,
      recordTotal_cu:0,
      consumerName:0,
      currentPage1:1,
      currentPage1_cu:1,
      userShops: JSON.parse(localStorage.getItem("shopIdInfo")),
      categoryList: [],
      secondCategory: [],
      tableData: [],
      orderTotal:0,//某个买家的订单总数
      offset_order:10,//默认每页数量
     currentPage1_or:1,//当前页数
      // tabName: 0,

      categoryPortrait: null,
      option: {
        title: {
          text: "类目: LossedLowValue",
        },

        toolbox: {
          show: true,
          feature: {
            saveAsImage: {},
          },
        },
        tooltip: {
          trigger: "axis",
        },
        radar: {
          indicator: [
            { name: "订单数(消费数)",min:0.2,max:1 },
            { name: "总消费金额",min:0.2,max:1},
            { name: "订单拒收数",min:0.2,max:1},
            { name: "最近一次消费至今间隔",min:0.2,max:1},
            { name: "平均消费时间间隔",min:0.2,max:1 },
            { name: "相对类目均价平均消费溢价比",min:0.2,max:1  },
          ],
        },
        series: [
          {
            name: "",
            type: "radar",
            data: [
              {
                value: [],
                name: "买家画像",
                areaStyle: {
                  color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: "rgb(198, 226, 255)",
                      offset: 0,
                    },
                    {
                      color: "rgb(83, 168, 255)",
                      offset: 1,
                    },
                  ]),
                },
              },
            ],
          },
        ],
      },
      tableData_user: [
        //买家订单详情数组
      ],
      tabName: "LossedLowValue",
      tabNames:'',//自定义分组默认
      tableData: [], //某个分类下的所有买家数组
       tableData_cu:[],//自定义分组下的买家
      dialogVisible: false,
      buyer_name: "",
     table_translation: {
        Lossed: this.$t('other.a2059'),
        Lossing:this.$t('other.a2060'),
        Ordinary:this.$t('other.a2061'),
        loyal:this.$t('other.a2062'),
        LowConsumption:this.$t('other.a2063'),
        HighConsumption:this.$t('other.a2064'),
        ordinary:this.$t('other.a2061'),
        PriceInsensitivity:this.$t('other.a2065'),
        PriceSensitive:this.$t('other.a2066'),
        HighConsumptionIII:this.$t('other.a2067'),
        ordinary:this.$t('other.a2061')

      },
       taxon:[],//类别
       mytext:this.$t('other.a2056'),
       hight:[],
       low:[],
       cene:[],
       common:[],
       timer:null,
       integral:null,
       btoonstatus:false,
    };
  },

  computed: {
    ...mapState({
      userId: (state) => state.shopaccess.userInfo.userId,
    }),
  },
  watch: {
    tabName() {
      var that = this;
      var queryData = this.categoryList.filter(function (fp) {
        return fp.category == that.tabName;
      });

      this.categoryPortrait = queryData[0];
      // this.categoryPortrait;
      this.setEchart();
    },
  },
  filters: {
    capitalize(country) {
      const obj = {
        TH: this.$t('other.a1305'),
        PH: this.$t('other.a1306'),
        ID: this.$t('other.a1307'),
        MY: this.$t('other.a1308'),
        VN: this.$t('other.a1310'),
      };

      return obj[country];
    },
  },
  created() {
    this.getvaild();
    // this.getuseringo();
    this.init();
    
    
    // this.tabclick();
    this.getcustom();
    this.getinteart();
    this.nation = JSON.parse(window.localStorage.getItem('userInfo')).country;
    console.log(this.nation);
    this.getShopList();
  },
  methods: {
    getShopList() {
      
      chat
        .getAuthorizedShopList({
          pageNum: 1,
          pageSize: 100,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res)
          if(res.pageInfo.total ==0){
              this.shops = true
          }else{
            this.showuser = true
          }
          }
         


        );
    },
    //打开授权页面
    authorizes() {
      console.log(this.userId);
      window.open("https://erp.shopsbu.com/cus/authorize/url/get?userId="+this.userId, "_blank");
    },
    valueCheack(){
      console.log(this.value)
      remind
        .getBuyerCategory({
          categoryName: this.tabName,
          pageNum: this.currentPage1,
          pageSize: this.offset,
          userId: this.userId,
          orderBy:this.value
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.userPortraits;
          
          console.log("买家名");
          console.log(this.tableData);
        });
    },
    gobottom(){
      window.scrollTo(0, 1800);
    },
    getinteart(){
      user
        .getSellerPoint({
          userId : this.userId
        })
        .then((res) => {
          console.log(res)
          this.integral = res.data.usableIntegral
        });
    },//获取用户积分
    getnum(integral)
		{
		var num = integral;
		if(typeof(num)=='undefined'){
		        return num
		    }else{
		        return Number(num).toFixed(2)
		    }
		
		
		
    },
    loopReslt(){
      this.timer = setInterval(() => {

        this.getuseringo();
         }, 1000)
      
      
    },
    calculate(){
      let integ = parseFloat(this.getnum(this.valid_data_num * 0.01))
      console.log(integ);
      if(integ > this.integral){
        this.$message.warning(this.$t('other.a2068'));
        return
      }
      if(this.valid_data_num == 0){
        this.$message.warning(this.$t('other.a2069'));
        return
      }
      if(this.valid_shop_list.length==0){
        this.$message.warning(this.$t('other.a2070'));
      }
      // this.showuser = null;
      // this.prostatus = true;
      this.takeout();
        // remind
        // .getcaluct({
        //   user_id : this.userId
        // })
        // .then((res) => {
        //   console.log(res)
        // });
        // this.loopReslt();//轮询
    },//发送计算请求
    tosucced(){
            this.prostatus = false
               this.showuser = true
               window.scrollTo(0, 0);
                 this.active = 0;
                 this.init();
                 this.getcustom();
                this.getinteart();
    },
    takeout(){
      let integ = parseFloat(this.getnum(this.valid_data_num * 0.01)) 
      let obj ={
        desc : '买家画像训练扣减',
        password : 'xrkj123@@',
        payIntegral : integ,
        sellerId : this.userId,
        userId : 'systemAdmin'
      }
      remind
        .deductingter(obj)
        .then((res) => {
          //  console.log(res)
          if(res.code == 200){
            this.showuser = null;
            this.prostatus = true;
              remind
              .getcaluct({
                userId  : this.userId
              })
              .then((res) => {
                console.log(res)
              });
              this.loopReslt();//轮询
          }
         
        });
    },
    showshopNameByshopIdOne(id){
		let obj= new Object();
		let shopList=utils.getAllshop().slice(1)
		shopList.forEach((p,index) => {
			obj[shopList[index].value]=p.label
			
		})
		return obj[id]
	},
    
    getuseringo(){
         remind
        .getUserInfo({
          userId   : this.userId,
        })
        .then((res) => {
          if(res.code == 'ok'){
            // console.log(res);
            this.progress_name = res.result.data.progress_name;
            this.num_progress = res.result.data.num_progress;
            this.all_progress = res.result.data.all_progress;
            if(res.result.data.progress_name == 'calculate indicators'){
              this.active = 1;
               this.stage = 25;
            }
             if(res.result.data.progress_name == 'calculate category'){
              this.active = 2;
               this.stage = 75;
            }
            if(res.result.data.progress_name == 'finish'){
              this.active = 3;
              this.stage = 100;
               clearInterval(this.timer); // 清理定时任务
               this.btoonstatus = true
              //  setTimeout(() => {
              //    this.prostatus = false
              //  this.showuser = true
              //    this.active = 0;
              //    this.init();
              //    this.getcustom();
              //   this.getinteart();
              //  }, 1000);
            }
         
          
         
          }
          
        });
    },
    getvaild(){
      remind
        .getvaild({
          userId   : this.userId,
          
        })
        .then((res) => {
          if(res.code === 'ok'){
            console.log(res.result)
            this.loading = false;
            
              this.valid_data_num = res.result.data.valid_data_num;
              this.valid_shop_list = res.result.data.valid_shop_list;
              
              // this.showuser = true
            
          }
          
        });
    },
    confirmModifyGroup(e){
      console.log(e);
      // this.tabNames = e.categoryId
      
       remind
        .updatecategory({
          categoryId  : e.categoryId,
          categoryName : this.GroupName,
        })
        .then((res) => {
          if(res.code == 'ok'){
            console.log(res);
            
          this.getcustom();
          
         
          }
          
        });
       
        this.GroupName = '';
       this.modifyGroup = true;
    },//修改自定义分组名称
    editgrop(e){
      this.GroupName = e.categoryName;
      this.modifyGroup =false
    },//打开输入框禁用
    collapfa(){
      console.log(this.Shared)
      this.tabclick_cu();
    },
    
    removeTab(tabNames){
      console.log(tabNames);
      remind
        .detelecategory({
          categoryId :tabNames
        })
        .then((res) => {
          console.log(res);
          this.getcustom();
        });
    },//删除自定义分组
    successshint(){
        remind
        .createcategory({
          categoryName : this.ruleForm.pass,
          description:this.ruleForm.checkPass,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          this.getcustom();
        });
        this.ruleForm.pass = '';
        this.ruleForm.checkPass = '';
        this.custom_hint = false;
    },//添加自定义分组
    opencustom(){
      this.custom_hint = true;
    },
    handleCurrentChange(currentPage){
      this.currentPage1 = currentPage
        console.log(this.currentPage1);
        remind
        .getBuyerCategory({
          categoryName: this.tabName,
          pageNum: this.currentPage1,
          pageSize: this.offset,
          userId: this.userId,
          orderBy:this.value
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.userPortraits;
          
          console.log("买家名");
          console.log(this.tableData);
        });
    },//分页
    handleCurrentChange_or(currentPage){
      this.currentPage1_or = currentPage;
      remind
        .getBuyerOrder({
          buyerUserName: this.buyer_name,
          pageNum: this.currentPage1_or,
          pageSize: this.offset_order,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          this.tableData_user = res.orders;
          // this.tableData = res.userPortraits
          // console.log(this.tableData);
        });
    },
    handleCurrentChange_cu(currentPage){
      this.currentPage1_cu = currentPage
        console.log(this.currentPage1_cu);
        remind
        .getcustomgroupuser({
          categoryId : this.tabNames,
          isShared:0,
           pageNum: this.currentPage1_cu,
          pageSize: this.offset_cu,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          this.tableData_cu = res.consumers;
          
          
        });
    },//分页
    handleSizeChange(size){
      this.offset =size;
      console.log(this.offset);
      remind
        .getBuyerCategory({
          categoryName: this.tabName,
          pageNum: this.currentPage1,
          pageSize: this.offset,
          userId: this.userId,
          orderBy:this.value
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.userPortraits;
          
          console.log("买家名");
          console.log(this.tableData);
        });
    },//改变每页数量
    handleSizeChange_cu(size){
      this.offset_cu =size;
      console.log(this.offset_cu);
      remind
        .getcustomgroupuser({
          categoryId : this.tabNames,
          isShared:0,
           pageNum: this.currentPage1_cu,
          pageSize: this.offset_cu,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          this.tableData_cu = res.consumers;
          
          
        });
    },
    handleSizeChange_or(size){
      this.offset_order = size;
      remind
        .getBuyerOrder({
          buyerUserName: this.buyer_name,
          pageNum: this.currentPage1_or,
          pageSize: this.offset_order,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          this.tableData_user = res.orders;
          // this.tableData = res.userPortraits
          // console.log(this.tableData);
        });
    },
    //汇率转换
    money(num){
      var lastmoney = (num * 6.3756).toFixed(2);
      return lastmoney;
    },
    getcustom(){
      remind
        .getcustomgroup({
          pageNum : 1,
          pageSize: 20,
          userId: this.userId,
        })
        .then((res) => {
          console.log('自定义分组')
          console.log(res.categories);
          this.customgroup = res.categories;
          this.customgroup_black= this.customgroup.filter(function(item){
                return item.categoryName == "黑名单"; 
          })
          
          console.log(this.customgroup_black);
          for (var i = 0;i < this.customgroup.length; i++){
              if (this.customgroup[i].categoryName== '黑名单'){
                  this.customgroup.splice(i,1);

              }

            }
          this.tabNames = res.categories[0].categoryId
          this.tabclick_cu();
        });
    },
    init() {
      api
        .getUserPictureImg({
          userName: this.userId,
        })
        .then((res) => {
          console.log(res);
          if (res.code === "ok") {
            console.log(res.category);
            this.categoryList = res.category;
            
            // for(var index in this.categoryList){
            //   this.taxon.push(this.categoryList[index].category_cn)
            // }
            // console.log(this.taxon);
            this.categoryPortrait = this.categoryList[0];
            // this.tabName = this.categoryList[0].category;
            
            
            this.setEchart();
            console.log(this.categoryPortrait)

            var arr = [];
            for (var i = 0; i < this.categoryList.length; i++) {
              if (this.categoryList[i].category_cn.indexOf('高价值') >= 0) {
                arr.push(this.categoryList[i]);
              }
            }
            console.log(arr);//高价值分类
            this.hight = arr;
            

            var arr1 = [];
            for (var i = 0; i < this.categoryList.length; i++) {
              if (this.categoryList[i].category_cn.indexOf('中价值') >= 0) {
                arr1.push(this.categoryList[i]);
              }
            }
            for (var i = 0; i < this.categoryList.length; i++) {
              if (this.categoryList[i].category_cn.indexOf('普通') >= 0) {
                arr1.push(this.categoryList[i]);
              }
            }
            console.log(arr1);//中等价值分类
            this.cene = arr1;

            var arr2 = [];
            for (var i = 0; i < this.categoryList.length; i++) {
              if (this.categoryList[i].category_cn.indexOf('低价值') >= 0) {
                arr2.push(this.categoryList[i]);
              }
            }
            console.log(arr2);//低价值分类
            this.low = arr2;

            var arr3 = [];
            for (var i = 0; i < this.categoryList.length; i++) {
              if (this.categoryList[i].category_cn.indexOf('普通') >= 0) {
                arr3.push(this.categoryList[i]);
              }
            }
            console.log(arr3);//低价值分类
            this.common = arr3;

            var arr4 = [];
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].category_cn.indexOf('粘性') >= 0) {
                arr4.push(arr[i]);
              }
            }
            console.log(arr4);//高价值粘性分类
           
            
            
            this.tabclick_s();
            // var arr1=this.categoryList.filter(function(item){
            //   return item.category_cn == '已流失高价值';

            //   });
            // var arr1 = this.categoryList.forEach(item=>item.category_cn.indexOf(this.mytext,2));
            // console.log(arr1)
          }
        });
    },
    cateGory(item, index) {
      console.log(item, index);
      this.$router.push({
        path: "/secondPicture",
        query: {
          categoryName: item.category,
        },
      });

      // if(index == 1){
      //     api
      //     .getUserPictureData({
      //         categoryName :item.category,
      //         pageNum:0,
      //         pageSize:15,
      //         userId:'indonesia'
      //     })
      //     .then(res => {
      //         console.log(res)
      //         if(res.code === 'ok'){

      //             this.secondCategory=res.userPortraits

      //         }
      //     })

      // }else if(index == 2) {
      //     api
      //     .buyerUser({
      //         buyerUserName  :item.userName,
      //         pageNum:0,
      //         pageSize:15,
      //         userId:'indonesia'
      //     })
      //     .then(res => {
      //         if(res.code === 'ok'){
      //             console.log(res)
      //            this.tableData=res.orders

      //         }
      //     })
      // }
    },
    //按钮触发

    setEchart() {
      var chartDom = document.getElementById("categoryPortraitEchart");
      var myChart = echarts.init(chartDom);
      var option = {
        title: {
          text: "类目: LossedLowValue",
        },

        toolbox: {
          show: true,
          feature: {
            saveAsImage: {},
          },
        },
        // tooltip: {
        //   trigger: "axis",
        // },
        radar: {
          indicator: [
            { name: "订单数(消费数)",min:-1,max:1 },
            { name: "总消费金额" ,min:-1,max:1 },
            { name: "订单拒收数",min:-1,max:1  },
            { name: "最近一次消费至今间隔",min:-1,max:1  },
            { name: "平均消费时间间隔",min:-1,max:1 },
            { name: "相对类目均价平均消费溢价比",min:-1,max:1 },
          ],
        },
        series: [
          {
            name: "",
            type: "radar",
            tooltip: {
              trigger: "item",
            },
            data: [
              {
                value: [],
                name: "买家画像",
                areaStyle: {
                  color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: "rgb(198, 226, 255)",
                      offset: 0,
                    },
                    {
                      color: "rgb(83, 168, 255)",
                      offset: 1,
                    },
                  ]),
                },
              },
            ],
          },
        ],
      };

      var arr = [];
      for (var i in this.categoryPortrait.standard) {
       
          arr.push(this.categoryPortrait.standard[i]);
        
      }
      
      option.series[0].data[0].value = arr;
      option.title.text = "类目:" + this.categoryPortrait.category_cn;
      option && myChart.setOption(option);
      console.log(arr);
      
    },

    tabclick() {
      console.log(this.tabName);
      this.currentPage1 = 1;
      remind
        .getBuyerCategory({
          categoryName: this.tabName,
          pageNum: this.currentPage1,
          pageSize: this.offset,
          userId: this.userId,
          orderBy:this.value
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.userPortraits;
          this.recordTotal = res.pageInfo.total
          console.log("买家名");
          console.log(this.tableData);
        });
    },
    // clicktable(){
    //   this.categorys_l = this.categorys[0].categoryName;
    //   console.log(this.categorys_l)
    // },
    tabclick_s(){
      
      console.log(this.categorys_l);
      if(this.categorys_l == 0){
          this.categoryList = this.hight;
        this.tabName = this.categoryList[0].category
          this.tabclick();
      }else if(this.categorys_l == 1){
          this.categoryList = this.cene
          this.tabName = this.categoryList[0].category
          this.tabclick();
      }else if(this.categorys_l == 2){
          this.categoryList = this.low
          this.tabName = this.categoryList[0].category
          this.tabclick();
      }
      
    },
    tabclick_cu(){
      console.log(this.tabNames);
      this.currentPage1_cu = 1;
      if(this.tabNames == 'f5483000-b5e0-46af-8263-2c50767c50ce'){
        remind
        .getcustomgroupuser({
          categoryId : this.tabNames,
          isShared:this.Shared,
           pageNum: this.currentPage1_cu,
          pageSize: this.offset_cu,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          if(res.code == 'ok'){
            this.tableData_cu = res.consumers;
            this.recordTotal_cu = res.pageInfo.total;
            console.log(this.tableData_cu);
          }
        });
      }else{
         remind
        .getcustomgroupuser({
          categoryId : this.tabNames,
          isShared:0,
           pageNum: this.currentPage1_cu,
          pageSize: this.offset_cu,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          if(res.code == 'ok'){
            this.tableData_cu = res.consumers;
            this.recordTotal_cu = res.pageInfo.total
            console.log(this.tableData_cu);
          }
        });
      }
     
    },//获取自定义分组下的所有买家
    //查看买家订单详情
    handleEdit(index, row) {
      this.dialogVisible = true;
      console.log(index, row);
      this.buyer_name = row.consumerName;
      this.getbuyer();
      remind
        .getBuyerOrder({
          buyerUserName: row.consumerName,
          pageNum: this.currentPage1_or,
          pageSize: this.offset_order,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res.pageInfo);
          console.log(res.orders);
          this.orderTotal = res.pageInfo.total;
          this.tableData_user = res.orders;
          // this.tableData = res.userPortraits
          // console.log(this.tableData);
        });
    },
    getbuyer(){
      
      remind
        .getBuyerAnalysis({
          buyerUserName: this.buyer_name,
         
          userId: this.userId,
        })
        .then((res) => {
          console.log(res.buyerUserPortrait.buyerUserPortrait);
          this.buyerUserPortrait = res.buyerUserPortrait.buyerUserPortrait
        });
    },//获取买家画像
    handleDelete(index, row) {
      console.log(index, row);
    },
    handleClose(done) {
      this.currentPage1_or = 1 ;
      this.dialogVisible = false;
    },
    handleClose_sh(){
      this.Sharing =false
    },
    handleClose_sh_yc(){
      this.Sharing_yc = false
    },
    Sharingbuyer(index,row){
      console.log(index);
      console.log(row);
      this.tabNames = row.categoryId;
      this.consumerName = row.consumerName;
      this.Sharing = true;
      console.log(this.tabNames);
      console.log(row.consumerName)
    },//共享{{$t('other.a2024')}}中的买家
    shiftbuyer(index,row){
      console.log(index);
      console.log(row);
      this.tabNames = row.categoryId;
       this.consumerName = row.consumerName;
       this.Sharing_yc = true;
    },
    Sharingck_yc(){
      remind
        .shareconsumer({
          categoryId : this.tabNames,
          consumerName : this.consumerName,
          description : this.describes,
          isShared : 0,
        })
        .then((res) => {
          if(res.code == 'ok'){
            this.$message({
          message: this.$t('other.a2071'),
          type: 'success'
        });
        this.tabclick_cu();
          }
          
          
          // this.tableData = res.userPortraits
          // console.log(this.tableData);
        });
        this.describes = '';
        this.Sharing_yc = false;
    },//移出共享
    Sharingck(){
        remind
        .shareconsumer({
          categoryId : this.tabNames,
          consumerName : this.consumerName,
          description : this.describe,
          isShared : 1,
        })
        .then((res) => {
          if(res.code == 'ok'){
            this.$message({
          message: this.$t('other.a2071'),
          type: 'success'
        });
        this.tabclick_cu();
          }
          
          
          // this.tableData = res.userPortraits
          // console.log(this.tableData);
        });
        this.describe = '';
        this.Sharing = false;
    },
    Sharingos(){
      this.describe = '';
      this.Sharing = false;
    },
    Sharingos_yc(){
      this.describes = '';
      this.Sharing_yc = false;
    },
     deleteconsumer(index,row){
       
       this.tabNames = row.categoryId;
    this.consumerName = row.consumerName;
    console.log(this.tabNames);
    console.log(this.consumerName);
      remind
        .deleteconsumer({
          categoryId : this.tabNames,
          consumerName : this.consumerName,
          
        })
        .then((res) => {
          if(res.code == 'ok'){
            this.$message({
          message: this.$t('other.a1232'),
          type: 'success'
          });
            this.tabclick_cu();
          }
          
          
         
        });
  },//删除自定义分组中的某个买家
    // ======================================
  },
 
};
</script>

<style lang="scss" scoped>
@import "~@assets/scss/mixins";
.clearfix{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pic-body{
  
  height: 300px;
 background: #eee;
    border-radius: 10px;
  padding: 15px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
}
.pic-one{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: bold;
  
  // color: #409eff;
  margin: 20px 0;
}
.pic-txt{
  text-indent:2em;
  font-size: 16px;
  font-weight: bold;
  margin: 6px 0;
  line-height: 30px;
}
.userPicture {
  // flex: 1;
  // margin: 50px 0 0 205px;
  box-sizing: border-box;
  padding: 0 20px;
  margin-bottom: 60px;
   .page{
              float: right;
              position: fixed;
              bottom: 0;
              left: 2rem;
              right: 2rem;
              height: 2.66rem;
              line-height: 2.66rem;
              // background-color: #fff;
              text-align:right;             
            }
  .user_card {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
  }
  .first_wrapper {
    
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .first_category {
      width: 400px;
      height: 19.7rem;
      box-sizing: border-box;
      padding: 5px;
      // margin: 5px 5px;
      border-radius: 3px;
      border: 1px solid #409eff;

      .item_category {
        padding: 4px;
        border-bottom: 1px solid #eee;
      }

      .item_category:nth-child(1) {
        font-size: 18px;
        font-weight: bold;
      }

      .item_category:nth-child(8) {
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
        color: #409eff;
        text-align: right;
      }
    }
  }

  .border {
    border: #409eff 0.02rem solid;
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .order_body{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-family: PingFang SC;
		font-weight: bold;
    // font-size: 24px;
  }
  .order_body_two{
    margin-left: 30px;
  }
  
}
.user_body{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 500px;
    
  }
  .user_top{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // height: 500px;
  }
  .user_top_s{
    display: flex;
    align-items: center;
    justify-content: center;
    // flex-direction: column;
    
  }
  .top_s{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
     width: 650px;
    height: 100px;
    background: #eee;
    border-radius: 10px;
    margin: 20px;
  }
  .pro-body{
    display: flex;
    align-items: center;
    justify-content: center;
   
  }
  .pro-all{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
     width: 550px;
    height: 500px;
    background: #eee;
    border-radius: 10px;
    padding: 20px;
  }
  .pro-one{
    width: 550px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    
  }
  .pro_pro{
    width: 550px;
    font-size: 22px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .prosta{
    width: 550px;
    margin-top: 15px;
    color: red;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pro-txt{
    width: 150px;
    height: 100px;
    padding: 15px;
    background: cornflowerblue;
    border-radius: 20px;
    color: #fff;
    font-weight: bold;
    font-size: 22px;
    display: flex;
    align-items: flex-start;
    justify-content: space-around;
    flex-direction: column;
  }
  .pro-two{
    width: 550px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 22px;
    font-weight: bold;
  }
  .user_body{
    width: 550px;
    padding:0 50px;
    background: #eee;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
</style>
